export type AuthSessionLoad = 'load' | 'clear' | 'ignore';

/**
 * Global data providers should fetch only after a real session exists.
 * INITIAL_SESSION fires for logged-out visitors too; treating that as "load"
 * hits Supabase with the anon key on /login.
 */
export function authSessionLoad(event: string, hasUser: boolean): AuthSessionLoad {
  if ((event === 'INITIAL_SESSION' || event === 'SIGNED_IN') && hasUser) return 'load';
  if (event === 'SIGNED_OUT' || (event === 'INITIAL_SESSION' && !hasUser)) return 'clear';
  return 'ignore';
}
